import common from '../locales/common';
import memoize from 'memoize-one';

export const merge = memoize((data) => {
  return Object.assign({}, common[Q.s('locale')], data[Q.s('locale')]);
});
